var DOC = document;

var CORE = {

	className: 'brtn-header--main__top__consult',

	elements: null,

	ConsultAs: function (form) {

		var CONSULTAS = {

			reset: {

				className: 'brtn-header--main__top__consult__reset',

				elements: null,

				onDone: function (response) {
					DOC.location.reload();
				},

				onReset: function (e) {
					e.preventDefault();

					$.ajax({
						method: 'POST',
						url: '/ajax/consultas.php',
						dataType: 'json',
						data: {
							ajax: 'reset',
						}
					}).done(CONSULTAS.reset.onDone);
				},

				construct: function () {
					var els = form.getElementsByClassName(CONSULTAS.reset.className);
					var i = 0;

					if (els == null || typeof els !== 'object' || !('length' in els) || !els.length) {
						return false;
					}
					CONSULTAS.reset.elements = [];

					for (i; i < els.length; i++) {
						CONSULTAS.reset.elements[CONSULTAS.reset.elements.length] = els[i];
						els[i].addEventListener('click', CONSULTAS.reset.onReset);
					}

				}

			},

			dropdown: {

				className: 'brtn-header--main__top__consult__dropdown',

				elements: null,

				onDone: function (response) {

					if (typeof response !== 'object' || !('state' in response) || response.state != 1) {
						CONSULTAS.dropdown.set('');
						return;
					}
					DOC.location.reload();
				},

				onItem: function (e) {
					var id;
					e.preventDefault();

					if (!('dataset' in this) || typeof this.dataset !== 'object') {
						return;
					}

					if (!('usr' in this.dataset)) {
						return;
					}
					id = parseInt(this.dataset.usr);

					if (typeof id !== 'number' || id <= 0) {
						return;
					}

					$.ajax({
						method: 'POST',
						url: '/ajax/consultas.php',
						dataType: 'json',
						data: {
							ajax: 'choose',
							usr: id,
						}
					}).done(CONSULTAS.dropdown.onDone);

				},

				items: function () {
					var els = form.getElementsByClassName(CONSULTAS.dropdown.className + '__item');
					var i = 0;

					if (els == null || typeof els !== 'object' || !('length' in els) || !els.length) {
						return false;
					}

					for (i; i < els.length; i++) {
						els[i].addEventListener('click', CONSULTAS.dropdown.onItem);
					}

				},

				set: function (content) {
					var els = CONSULTAS.dropdown.elements;
					var i = 0;

					if( els === null ){
						return false;
					}
					content = typeof content === 'string' ? content : '';

					for (i; i < els.length; i++) {
						els[i].innerHTML = content;
					}

					return true;

				},

				construct: function () {
					var els = form.getElementsByClassName(CONSULTAS.dropdown.className);
					var i = 0;

					if (els == null || typeof els !== 'object' || !('length' in els) || !els.length) {
						return false;
					}
					CONSULTAS.dropdown.elements = [];

					for (i; i < els.length; i++) {
						CONSULTAS.dropdown.elements[CONSULTAS.dropdown.elements.length] = els[i];
					}

				}


			},

			input: {

				className: 'brtn-header--main__top__consult__picker',

				elements: null,

				onDone: function (response) {

					if (typeof response !== 'object' || !('state' in response) || !('content' in response) || typeof response.content !== 'string') {
						CONSULTAS.dropdown.set('');
						return;
					}
					CONSULTAS.dropdown.set(response.content);
					CONSULTAS.dropdown.items();

				},

				onChange: function (e) {
					var val = this.value;

					e.preventDefault();

					if (typeof val !== 'string' || val.length < 3) {
						return;
					}

					$.ajax({
						method: 'GET',
						url: '/ajax/consultas.php',
						dataType: 'json',
						data: {
							ajax: 'search',
							query: val,
						}
					}).done(CONSULTAS.input.onDone);

				},

				construct: function () {
					var self = CONSULTAS.input;
					var elements = form.getElementsByClassName(self.className);
					var i = 0;

					if (typeof elements !== 'object' || elements == null || !elements.length) {
						return;
					}
					self.elements = [];

					for (i; i < elements.length; i++) {
						self.elements[self.elements.length] = elements[i];
						elements[i].addEventListener('input', self.onChange);
					}

				}

			}

		};
		CONSULTAS.input.construct();
		CONSULTAS.dropdown.construct();
		CONSULTAS.reset.construct();

	},

	construct: function () {
		var els = DOC.getElementsByClassName(CORE.className);
		var i = 0;

		if (els == null || typeof els !== 'object' || !('length' in els) || !els.length) {
			return false;
		}
		CORE.elements = [];

		for (i; i < els.length; i++) {
			CORE.elements[CORE.elements.length] = els[i];
			CORE.ConsultAs(els[i]);
		}

	},

};

export default CORE.construct;